const controller = {
  getUserItemTypesFromIndex(index: number) {
    if (index === 0) {
      return ['favorite,inquiry'];
    } else if (index === 1) {
      return ['favorite'];
    } else {
      return ['inquiry'];
    }
  },
};

export default controller;
